import { GENERATORS } from "../../config/generators";

export { default as Page } from "./Page";
export { default as ImageZoom } from "./ImageZoom";
export { default as FileDrop } from "./FileDrop";
export { default as StatusBadge } from "./StatusBadge";
export { default as GalleryGrid } from "./GalleryGrid";
export { default as ViewSwitch } from "./ViewSwitch";
export { LoadingState, ErrorState, EmptyState } from "./StateView";
export { default as LazyImage } from "./LazyImage";
export { default as ColorDot } from "./ColorDot";
export { default as ConfirmButton } from "./ConfirmButton";
export { default as DownloadButton } from "./DownloadButton";

/** Tab options for the Gallery / Generate section switchers - one per generator. */
export const GENERATOR_VIEWS = GENERATORS.map((g) => ({ label: g.label, value: g.key }));
